import {
  View,
  Text,
  FlatList,
  Image,
  TouchableOpacity,
  TextInput,
  ActivityIndicator,
  Platform,
} from "react-native";
import React, { useEffect, useState } from "react";
import i18n from "../../../locales/i18n";
import DateItem from "../../../components/DateItems";
import AntDesign from "@expo/vector-icons/AntDesign";
import StandardNavigation from "../../../components/navigation/StandardNavigation";
import { Toast } from "react-native-toast-notifications";
import Animated, { FadeInDown, LinearTransition } from "react-native-reanimated";
import { router, useFocusEffect } from "expo-router";
import customAxios from "../../../utils/customAxios";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import DeptHeaderIcon from "../../../assets/dept/dept.svg";
import { useCallback } from "react";
import WebDettesScreen from "../../../components/web/WebDettesScreen";
interface DebtItem {
  id_debt?: number;
  createdAt?: string;
  amount?: number;
  paidamount?: number;
  fullname?: string;
}

const DettesScreen = () => {
  const { locale } = useSelector((state: RootState) => state.app);
  const [datas, setdatas] = useState<DebtItem[]>([]);
  const [buttonSpinner, setButtonSpinner] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  // Safe function to set datas - ensures it's always an array
  const safeSetDatas = (data: any) => {
    setdatas(Array.isArray(data) ? data : []);
  };

  // Function to fetch debts
  const handelGetProducts = async () => {
    try {
      setButtonSpinner(true);
      const res = await customAxios.get(`/debt`, {
        withCredentials: true,
      });

      setButtonSpinner(false);
      // Ensure we always set an array, even if the response is null/undefined
      const responseData = res?.data;
      safeSetDatas(responseData);
    } catch (error) {
      setButtonSpinner(false);
      // Ensure datas is reset to empty array on error
      safeSetDatas([]);
      // Toast.show(i18n.t("errorFetchingDebts"), {
      //   type: "danger",
      // });
    }
  };

  // Initial load
  useEffect(() => {
    handelGetProducts();
  }, []);

  // Refresh debts when screen comes into focus (when returning from add-debt screen)
  useFocusEffect(
    useCallback(() => {
      // Only refresh if we have search value cleared or no search is active
      if (!searchValue) {
        handelGetProducts();
      }
    }, [searchValue])
  );

  const handelSearch = (value: string) => {
    setSearchValue(value);
  };
  const handelSearchProduct = async (productName: string) => {
    setButtonSpinner(true);
    try {
      const res = await customAxios.get(
        `/debt/search/byinfo?info=${productName}`
      );
      // Ensure we always set an array, handle both empty results and null/undefined responses
      const searchResults = res.data;
      safeSetDatas(searchResults);
    } catch (error) {
      safeSetDatas([]); // Reset to empty array on error
      Toast.show(i18n.t("errorsearch"), {
        type: "danger",
      });
    } finally {
      setButtonSpinner(false);
    }
  };

  const handelAdd = () => {
    router.push("/(drawer)/dettes/add-dette");
  };

  // Render web version on web platform
  if (Platform.OS === "web") {
    return <WebDettesScreen />;
  }

  return (
    <View style={{ flex: 1, backgroundColor: "#f5f5f5" }}>
      {/* Standard Navigation */}
      <StandardNavigation
        title={i18n.t("credit")}
        showBackButton={true}
        showMenuButton={true}
        showLogo={true}
        icon={<DeptHeaderIcon width={30} height={30} />}
      />

      <View className=" relative flex-1 ">
        <View
          style={{
            width: "100%",
            paddingHorizontal: 16,
            paddingTop: 16,
            paddingBottom: 20,
            backgroundColor: "#0596D0", // Match StandardNavigation background
            borderBottomLeftRadius: 20,
            borderBottomRightRadius: 20,
          }}
        >
          <Animated.View
            entering={FadeInDown.delay(50).duration(500)}
            className={`${
              locale == "fr" ? "flex-row" : "flex-row-reverse"
            }     justify-center flex     items-center `}
          >
            <View className="relative  flex-1">
              <TextInput
                placeholder={i18n.t("searchadate")}
                autoCapitalize="none"
                placeholderTextColor="#666"
                className={`${
                  locale == "ar" ? "text-right pr-12" : "text-left pl-4"
                }     font-bold          text-black  text-lg `}
                style={{
                  backgroundColor: "white",
                  width: "100%",
                  borderRadius: 50,
                  paddingVertical: 12,
                  paddingRight: locale == "ar" ? 48 : 16,
                  paddingLeft: locale == "ar" ? 16 : 48,
                }}
                onChangeText={(value) => {
                  handelSearchProduct(value);
                }}
              ></TextInput>
              <TouchableOpacity
                onPress={() => {
                  handelSearch(searchValue);
                }}
                className={`${
                  locale == "fr" ? "left-4" : "right-4"
                }   absolute top-3`}
              >
                <AntDesign name="search" size={24} color="#666" />
              </TouchableOpacity>
            </View>
          </Animated.View>
        </View>

        <Animated.View
          entering={FadeInDown.duration(600).delay(100)}
          className={`${
            locale == "ar" ? "flex-row" : "flex-row-reverse"
          }     w-full mt-4 flex  justify-between rounded-xl px-2 py-3 `}
          style={{
            backgroundColor: "#FFFFFF",
            marginHorizontal: 10,
            elevation: 2,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.1,
            shadowRadius: 2,
          }}
        >
          <Text className="font-bold flex-1 text-center text-sm text-gray-800">
            {i18n.t("dateofdette")}
          </Text>
          <Text className="font-bold flex-1 text-center text-sm text-gray-800">
            {i18n.t("total")}
          </Text>
          <Text className="font-bold flex-1 text-center text-sm text-gray-800">
            {i18n.t("paidamount")}
          </Text>
          <Text className="font-bold flex-1 text-center text-sm text-gray-800">
            {i18n.t("remaining")}
          </Text>
          <Text className="font-bold flex-1 text-center text-sm text-gray-800">
            {i18n.t("nameofdetn")}
          </Text>
        </Animated.View>

        {Array.isArray(datas) &&
          datas &&
          datas.length > 0 &&
          !buttonSpinner && (
            <Animated.FlatList
              data={datas || []}
              itemLayoutAnimation={LinearTransition.springify()}
              contentContainerStyle={{
                padding: 10,
                paddingBottom: 20,
              }}
              keyExtractor={(item) =>
                item?.id_debt?.toString() || Math.random().toString()
              }
              showsVerticalScrollIndicator={false}
              renderItem={({ item, index }) =>
                item && (
                  <Animated.View entering={FadeInDown.duration(400).delay(index * 50)}>
                    <DateItem element={item} index={index} />
                  </Animated.View>
                )
              }
            />
          )}

        {buttonSpinner && (
          <View className="flex-1 justify-center items-center">
            <ActivityIndicator size="large" color="green" />
            <Text className="font-bold text-black mt-4 text-lg">
              {i18n.t("loading")}
            </Text>
          </View>
        )}

        {Array.isArray(datas) &&
          datas &&
          datas.length === 0 &&
          !buttonSpinner && (
            <View className="flex-1 justify-center items-center">
              <Text className="font-bold text-black text-lg">
                {i18n.t("nodata")}
              </Text>
            </View>
          )}

        <Animated.View entering={FadeInDown.duration(600).delay(300)}>
          <TouchableOpacity
            onPress={handelAdd}
            className="rounded-full absolute py-2   px-4 bg-[#434343] bottom-20 right-8"
          >
            <Text className="text-white font-bold text-xl">
              {i18n.t("adddate")}
            </Text>
          </TouchableOpacity>
        </Animated.View>
      </View>
    </View>
  );
};

export default DettesScreen;
